// File types a doc capture step can accept. Kept in sync with the runtime's
// DOC_CAPTURE_DEFAULT_ALLOWED_TYPES (stm_consts.py) and the backend's
// ALLOWED_FILE_EXTENSIONS (runtime/doc-capture/upload-url-gen) - the runtime is
// what actually enforces the step's choice when the file is processed.
export const DOC_CAPTURE_FILE_TYPES = ['pdf', 'doc', 'docx', 'csv', 'txt', 'md', 'png', 'jpg'];

export const DOC_CAPTURE_DEFAULT_FILE_TYPES = ['pdf', 'docx', 'csv', 'txt', 'md', 'png', 'jpg'];

// stateConfig.type the canvas writes for this node; `handle_prompt` in the
// runtime dispatches on it.
export const DOC_CAPTURE_PROMPT_TYPE = 'doc_capture';
